module.exports = __webpack_public_path__ + "img/ring_r_o_1_0@3x.cd37cb5d.png";